import { createStandardAction } from 'typesafe-actions'
import { FeatureFlagsState } from './types'

export const SET_FEATURE_FLAGS = 'experiment/SET_FEATURE_FLAGS'

export const setFeatureFlags = createStandardAction(SET_FEATURE_FLAGS)<
  FeatureFlagsState
>()



// WEBPACK FOOTER //
// ./src/state/featureFlags/actions.ts